import { Stack } from '@mui/material';
import React from 'react';

import { DotIcon } from '@/shared/assets/icons/dot-icon';
import { AdditionalInfo } from '@/shared/components/ui/form/components/searchable-select/base-searchable-select.styled';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';
import { TUserAdditionalInfoProps } from '@/shared/features/rbac/components/user-select/user-additional-info/user-additional-info.types';
import { useRbacConfig } from '@/shared/features/rbac/context/rbac-config-context';
import { UserSourceEnum } from '@/shared/types/types.generated';
import { getResellerBranding } from '@/shared/utils/reseller-branding/reseller-branding';

export const UserAdditionalInfo: React.FC<TUserAdditionalInfoProps> = ({
  user,
  ssoEnabled: ssoEnabledOverride,
}) => {
  const { useTenantSettings } = useRbacConfig();
  const { ssoEnabled: contextSsoEnabled } = useTenantSettings();
  const ssoEnabled = ssoEnabledOverride ?? contextSsoEnabled;
  const resellerAbbreviation = getResellerBranding().abbreviation;

  const getUserSource = () => {
    if (user.source === UserSourceEnum.Sda) {
      return resellerAbbreviation;
    }
    return user.source;
  };

  return (
    <Stack direction="row" alignItems="center">
      <TruncatedText
        text={user.email}
        maxLength={20}
        variant="p10"
        color="textSecondary"
      />
      {ssoEnabled && (
        <AdditionalInfo>
          <DotIcon size="3px" />
          {getUserSource()}
        </AdditionalInfo>
      )}
    </Stack>
  );
};
